<template>
  <div class="points-exchange">
    <!-- 积分兑换 -->
    <NavHeaderBar :navBarTitle="$t('shared.title.pointsRedemption')" :isShowLogo="false">
    </NavHeaderBar>
    <div v-if="!successStatus" class="points-content">
      <div class="header-info">
        <div class="left-info">
          <div class="store-name">{{ currentEmployee.nickname }}</div>
          <div class="store-type" :style="{ 'color': currentEmployee.jobColor, 'border': `1px solid ${currentEmployee.jobColor}` }">{{ currentEmployee.job }}</div>
        </div>
        <div class="point-num">{{ currentEmployee.integral }} Point</div>
      </div>
      <div class="gift-info">
        <!-- 选择本次兑换的礼品 -->
        <div class="title">{{ $t('shared.selectGiftToRedeem') }}</div>
        <div class="gift-show">
          <van-radio-group v-model="pointsRadio">
            <van-cell-group>
              <van-cell
                v-for="(item) in redeemList"
                clickable
                :key="item.id"
                @click="handleRadio(item)"
              >
                <template #title>
                  <van-radio shape="square" :name="item.id" style="pointer-events:none" />
                </template>
                <template #default>
                  <div class="gift-item">
                    <img v-if="item.imgUrl" class="img-icon" :src="item.imgUrl" alt="" @click.stop="imgPreview(item.imgUrl)">
                    <img v-else class="img-icon" src="@/assets/images/icon_noimg.png" alt="">
                    <div class="item-desc">
                      <div class="gift-name txt-ellipsis">{{ item.redeemName }}</div>
                      <div>{{ $t('shared.need') }}：{{ item.needIntegral }} {{ $t('shared.point') }}</div>
                    </div>
                  </div>
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
      </div>
      <div class="photo-info">
        <!-- 交付照片 -->
        <div class="title">{{ $t('shared.proofOfDelivery') }}</div>
        <van-uploader v-model="imgUrl" :after-read="(files, detail) => afterRead(files, detail, 'imgUrl')" />
      </div>
    </div>
    <div class="success-submit-status" v-else @click="toUrl(`/pointsDetail?employeeId=${employeeId}`)">
      <img class="success-img" src="@/assets/images/gouxuan.png" alt="">
      <!-- 兑换成功，已从该员工账号扣除{{ currentIntegral }}积分 -->
      <span class="success-tip">{{ $t('shared.titleTwentyOne', { currentIntegral: currentIntegral }) }}.</span>
      <!-- 积分明细 -->
      <div class="success-btn">{{ $t('shared.creditBreakdown') }}</div>
    </div>
    <div class="oper-btn" v-if="!successStatus">
      <!-- 确认兑换 积分不足 -->
      <van-button class="mapping-btn" :class="{'fail-btn': !isExchange}" type="info" @click="handleConfirm">{{ isExchange ? $t('shared.confirmRedemaption') : $t('shared.insufficientPoints') }}</van-button>
    </div>
  </div>
</template>

<script>
import { Toast, ImagePreview } from 'vant'
import { arsActivityRedeemListApi, arsActivityEmployeeInfoApi, arsActivityOrderRedeemApi } from '@/api/home'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      pointsRadio: '',
      currentIntegral: '',
      imgUrl: [],
      currentEmployee: {},
      redeemList: [],
      isExchange: true,
      successStatus: false,
      employeeId: ''
    }
  },
  computed: {
    ...mapState({
      globalData: 'globalData'
    })
  },
  activated () {
    this.employeeId = this.$route.query.employeeId
    this.getEmployeeData()
    this.getRedeemData()
  },
  deactivated () {
    this.$destroy()
  },
  methods: {
    getRedeemData () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      arsActivityRedeemListApi().then(res => {
        Toast.clear()
        this.redeemList = res.data
      })
    },
    getEmployeeData () {
      arsActivityEmployeeInfoApi(this.$route.query.employeeId).then(res => {
        this.globalData.customerJob.find((paramsItem) => {
          if (res.data.job === paramsItem.label && paramsItem.value) {
            res.data.jobColor = JSON.parse(paramsItem.value).color
            return paramsItem
          }
        })
        this.currentEmployee = res.data
      })
    },
    afterRead (files, detail, key) {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      this.$uploadImg(files)
        .then((res) => {
          Toast.clear()
          this.$set(this[key], detail.index, {
            url: res.url
          })
        })
        .catch((err) => {
          console.log('err', err)
          Toast.clear()
          Toast(this.$t('tips.uploadFailed'))
        })
    },
    handleRadio (params) {
      if (this.pointsRadio === params.id) {
        this.pointsRadio = ''
        this.currentIntegral = ''
      } else {
        this.pointsRadio = params.id
        this.currentIntegral = params.needIntegral
      }
      if (params.needIntegral > this.currentEmployee.integral) {
        this.isExchange = false
      } else {
        this.isExchange = true
      }
    },
    handleConfirm () {
      if (!this.isExchange || !this.pointsRadio || this.imgUrl.length <= 0) {
        const tips = !this.pointsRadio || this.imgUrl.length <= 0 ? this.$t('tips.messageTwentyEight') : this.$t('shared.insufficientPoints')
        Toast(tips)
        return
      }
      const { customerId, employeeId } = this.$route.query
      const data = {
        customerId: customerId,
        employeeId: employeeId,
        redeemId: this.pointsRadio,
        imgUrl: this.imgUrl.map(subItem => subItem.url).join(',')
      }
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      arsActivityOrderRedeemApi(data).then(res => {
        Toast.clear()
        this.successStatus = true
      })
    },
    toUrl (url) {
      this.$router.push(url)
    },
    imgPreview (url) {
      ImagePreview([url])
    }
  }
}
</script>

<style lang="less" scoped>
.points-exchange {
  display: flex;
  flex-direction: column;
  height: 100%;
  .points-content {
    flex: 1;
    overflow-y: auto;
    padding: 10px;
    .header-info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 26px 16px;
      background-color: #d7d7d7;
      border-radius: 10px;
      .store-name {
        color: #333;
        margin-bottom: 6px;
      }
      .store-type {
        padding: 2px 5px;
        border: 1px solid #307bff;
        color: #307bff;
        background-color: #fff;
      }
      .point-num {
        font-weight: bold;
        font-size: 15px;
        color: #307bff;
      }
    }
    .gift-info {
      margin-top: 20px;
      margin-bottom: 16px;
      /deep/.van-hairline--top-bottom::after {
        display: none;
      }
      /deep/.van-cell {
        padding: 10px 0;
        // border-bottom: 1px solid #d2dcec;
        border-bottom: 1px solid rgba(210, 220, 236, .5);
        &:first-child {
          border-top: 1px solid rgba(210, 220, 236, .5);
        }
        &::after {
          display: none;
        }
        .van-cell__title {
          padding-top: 20px;
          flex: none;
        }
        .van-cell__value {
          padding-left: 10px;
          text-align: left;
        }
      }
      .gift-item {
        display: flex;
        .item-desc {
          flex: 1;
          font-size: 12px;
          margin-left: 10px;
          color: #333;
          .gift-name {
            width: 236px;
            margin-bottom: 10px;
          }
        }
        .img-icon {
          width: 60px;
          height: 60px;
        }
      }
    }
    .gift-info,
    .photo-info {
      .title {
        margin-bottom: 13px;
        position: relative;
        padding-left: 10px;
        &::before {
          content: '*';
          color: #ff4444;
          position: absolute;
          left: 0;
          top: 0;
          font-size: 14px;
          line-height: 1;
        }
      }
    }
  }
  .success-submit-status {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 100px;
    .success-img {
      width: 60px;
      height: 60px;
    }
    .success-tip {
      font-size: 14px;
      margin: 16px 0 40px 0;
    }
    .success-btn {
      padding: 16px 50px;
      border: 1px solid #307BFF;
      color: #307BFF;
      font-weight: bold;
      font-size: 16px;
      border-radius: 30px;
    }
  }
  .oper-btn {
    width: 100%;
    .mapping-btn {
      width: 100%;
      background-color: #307bff;
      font-weight: bold;
    }
    .fail-btn {
      background-color: #aaaaaa;
      border: 1px solid #aaa;
    }
  }
}
</style>
